module.exports = __webpack_public_path__ + "images/category_lp/common/icon-satei_31171dd641b40b2999ce3cfd24a87702.png";